import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { connect } from 'react-redux'

import type { RootState } from './store/reducers'
import type { AuthenticateSmartcheckSessionDto } from './types/authenticateSmartcheckSessionDto'

import { intercomService } from './services/intercomService'
import { isIntercomEnabledForSession } from './utils/intercom'

interface IntercomConfiguratorProps {
	smartCheckSession?: AuthenticateSmartcheckSessionDto
	applicantId: string | null
}

const IntercomConfigurator = (props: IntercomConfiguratorProps) => {
	const [initialized, setInitialized] = useState(false)
	const { i18n } = useTranslation()

	useEffect(() => {
		const { smartCheckSession, applicantId } = props
		if (
			i18n.language === 'cimode' ||
			initialized ||
			smartCheckSession == null ||
			!isIntercomEnabledForSession(smartCheckSession.client.id)
		) {
			return
		}

		window.intercomSettings = {
			app_id: 'cdmkygdr',
			custom_launcher_selector: '#monthio_faq_button',
			hide_default_launcher: window.innerWidth <= 600,
			background_color: '#132179',
			client_id: smartCheckSession.client.id,
			case_configuration_id: smartCheckSession.smartCheckConfiguration.id,
			applicant_id: applicantId,
			region_id: smartCheckSession.regionId,
		}
		window.loadIntercom()
		intercomService.initialize()

		setInitialized(true)
	}, [props.smartCheckSession])

	return null
}

function mapStateToProps(state: RootState) {
	return {
		smartCheckSession: state.authentication.smartCheckAuthenticationDto,
		applicantId: state.authentication.applicantId,
	}
}

export default connect(mapStateToProps)(IntercomConfigurator)
